import type { SvgIconPropsWithChildren } from '../components/SvgIcon';

import React, { createElement } from 'react';

import { SvgIcon } from '../components/SvgIcon';

function SvgBullhorn(props: SvgIconPropsWithChildren) {
  return createElement(
    SvgIcon,
    props,
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        d="M22.113,8.042l-1.092-6.365C20.9,0.972,20.232,0.501,19.53,0.622c-2.204,2.671-6.05,6.28-11.222,7.169 L1.943,8.882C0.888,9.064,0.18,10.066,0.36,11.121l0.656,3.817c0.182,1.056,1.184,1.764,2.239,1.582l0.669-0.115 c0.188,2.37,1.326,4.157,2.186,5.834c0.093,0.19,0.234,0.349,0.407,0.471c0.807,0.57,1.822,0.801,2.785,0.636 c1.264-0.218,2.308-1.09,2.677-2.412c0.178-0.634-0.144-1.298-0.753-1.546c-1.23-0.504-1.427-0.677-1.28-1.073 c0.19-0.524,0.02-1.117-0.426-1.464c-0.251-0.195-0.237-1.084,0.204-1.441c5.133-0.844,9.918,1.266,12.87,3.035 c0.705-0.12,1.177-0.787,1.055-1.492l-1.094-6.364c0.704-0.121,1.176-0.787,1.054-1.492C23.487,8.392,22.817,7.92,22.113,8.042z  M10.74,20.581c-0.442,1.578-2.273,1.921-3.479,1.071c-0.854-1.675-1.918-3.321-2.057-5.465l2.935-0.503 c-0.201,0.82-0.016,1.727,0.593,2.192C8.174,19.391,9.43,20.049,10.74,20.581z M2.291,14.721l-0.655-3.817 c-0.061-0.35,0.178-0.686,0.526-0.747l7.002-1.203l0.875,5.092L3.036,15.25C2.687,15.309,2.35,15.071,2.291,14.721z M22.304,16.789 c-1.655-0.908-3.338-1.616-5.017-2.098c-2.038-0.587-4.033-0.835-5.956-0.743l-0.916-5.333c1.841-0.558,3.641-1.457,5.366-2.691 c1.418-1.018,2.772-2.241,4.03-3.649L22.304,16.789z"
      />
    </svg>
  );
}
export default SvgBullhorn;
